"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6778],{

/***/ 79836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ TooltipText; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




// {color, font-size} ARE INHERITED PROPERTIES
// TO CUSTOMIZE A COMPONENT JUST USE CLASSNAME

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "IconTooltip__Wrapper", componentId: "sc-6xhp10-0" })(["position:relative;display:inline-flex;margin:0;"]);





var TooltipText = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].p.withConfig({ displayName: "IconTooltip__TooltipText", componentId: "sc-6xhp10-1" })(["display:", ";position:absolute;top:100%;right:", "px;width:400px;max-width:90vw;white-space:wrap;border-radius:5px;padding:10px;margin-right:-6vw;margin-top:10px;background-color:", ";box-shadow:0px 1px 2px 1px rgba(0,0,0,0.1);&:after,&:before{bottom:100%;left:", ";border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(136,183,213,0);border-bottom-color:", ";border-width:5px;margin-left:-5px;}&:before{border-color:rgba(194,225,245,0);border-bottom-color:", ";border-width:6px;margin-left:-6px;}"],
function (_ref) {var show = _ref.show;return show ? 'initial' : 'none';},


function (_ref2) {var position = _ref2.position;return position !== null && position !== void 0 ? position : 0;},







function (props) {return props.theme.colors.neutrals['white-darker'];},





function (_ref3) {var position = _ref3.position;
  // add 5 to center tooltip under icon
  return "".concat(position + 5, "px");
},










function (props) {return (
    props.theme.colors.neutrals['white-darker']);},






function (props) {return (
    props.theme.colors.neutrals['white-darker']);});



















var iconDefaults = {
  color: 'gray',
  fontSize: '14px' };


var IconTooltip = function IconTooltip(_ref4)





{var className = _ref4.className,children = _ref4.children,translationId = _ref4.translationId,showTooltip = _ref4.showTooltip,_ref4$icon = _ref4.icon,icon = _ref4$icon === void 0 ? {} : _ref4$icon;
  var tooltipAnchor = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),position = _useState[0],setPosition = _useState[1];
  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),tooltipVisible = _useState2[0],setTooltipVisible = _useState2[1];

  var updateTooltipPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    var tooltipAnchorEl = tooltipAnchor === null || tooltipAnchor === void 0 ? void 0 : tooltipAnchor.current;
    var tooltipEl = tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current;
    if (tooltipAnchorEl && tooltipEl) {
      var _tooltipAnchorEl$getB = tooltipAnchorEl === null || tooltipAnchorEl === void 0 ? void 0 : tooltipAnchorEl.getBoundingClientRect(),anchorLeft = _tooltipAnchorEl$getB.left;
      var _tooltipEl$getBoundin = tooltipEl === null || tooltipEl === void 0 ? void 0 : tooltipEl.getBoundingClientRect(),width = _tooltipEl$getBoundin.width;

      var left = -50;
      if (anchorLeft + left + width > window.innerWidth) {
        left = window.innerWidth - (anchorLeft + width) - 20;
      }
      tooltipEl.style.left = left + 'px';
      setPosition(-left);
    }
  }, [tooltipAnchor === null || tooltipAnchor === void 0 ? void 0 : tooltipAnchor.current, tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current]);

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (tooltipVisible) {
      updateTooltipPosition();
    }
  }, [tooltipVisible]);

  var events = {},
  IconElement;

  // component controlled externally
  if (!showTooltip) {
    events = {
      onMouseOver: function onMouseOver() {return setTooltipVisible(true);},
      onMouseOut: function onMouseOut() {return setTooltipVisible(false);} };

  }

  if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(icon)) {
    IconElement = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(icon, _objectSpread({}, events));
  } else {
    var iconProps = Object.assign(iconDefaults, icon);
    IconElement = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({ name: "ygb-icon-questionb" }, iconProps), events));
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Wrapper, { ref: tooltipAnchor, className: "iconTooltip ".concat(className), children: [
      IconElement, /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TooltipText, {
        ref: tooltipRef,
        show: tooltipVisible || showTooltip,
        position: position, children:

        translationId ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: translationId }) : children })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (IconTooltip);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 61231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Footer": function() { return /* binding */ Footer; },
  "LeftContainer": function() { return /* binding */ LeftContainer; },
  "Logo": function() { return /* binding */ Logo; },
  "Paragraph": function() { return /* binding */ Paragraph; },
  "RightContainer": function() { return /* binding */ RightContainer; },
  "Wrapper": function() { return /* binding */ Wrapper; },
  "default": function() { return /* binding */ layout_register; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/footer.register.tsx
var _excluded = ["lang"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var FooterWrapper = (0,styled_components_browser_esm["default"])(Grid/* Flex */.kC).withConfig({ displayName: "footerregister__FooterWrapper", componentId: "sc-17533wl-0" })(["flex-wrap:wrap;color:", ";padding:20px;"],

function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.gray;});



var Text = styled_components_browser_esm["default"].p.withConfig({ displayName: "footerregister__Text", componentId: "sc-17533wl-1" })(["font-size:13px;font-weight:300;line-height:16px;opacity:0.8;margin:10px 20px;"]);







var LangaguesList = styled_components_browser_esm["default"].ul.withConfig({ displayName: "footerregister__LangaguesList", componentId: "sc-17533wl-2" })(["display:flex;font-weight:600;list-style:none;padding-left:0;margin:0 20px;"]);







var Language = styled_components_browser_esm["default"].li.withConfig({ displayName: "footerregister__Language", componentId: "sc-17533wl-3" })(["& + &{margin-left:20px;}"]);





var Anchor = styled_components_browser_esm["default"].a.withConfig({ displayName: "footerregister__Anchor", componentId: "sc-17533wl-4" })(["color:inherit;text-decoration:none;"]);




var langs = [
{ text: 'Svenska', key: 'se' },
{ text: 'English', key: 'en' },
{ text: 'Norsk', key: 'no' },
{ text: 'Suomi', key: 'fi' }];


var RegisterFooter = function RegisterFooter(props) {
  var router = (0,next_router.useRouter)();
  var pathname = router.pathname;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(FooterWrapper, _objectSpread(_objectSpread({}, props), {}, { alignItems: "center", justifyContent: "center", children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Text, { children: ["\xA9YOGOBE ", new Date().getFullYear(), ". All rights reserved."] }), /*#__PURE__*/
      (0,jsx_runtime.jsx)(LangaguesList, { children:
        langs.map(function (item) {
          var _router$query = router.query,_ = _router$query.lang,params = (0,objectWithoutProperties/* default */.Z)(_router$query, _excluded);
          var url = Object.keys(params).
          reduce(
          function (url, param) {return (
              url.replace("[".concat(param, "]"), router.query[param]));},
          pathname).

          replace("[lang]", item.key);

          return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(Language, { children: /*#__PURE__*/
              (0,jsx_runtime.jsx)((link_default()), { href: pathname, as: url, legacyBehavior: true, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(Anchor, { href: url, children: item.text }) }) }, item.key));



        }) })] })));



};

/* harmony default export */ var footer_register = (RegisterFooter);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
;// CONCATENATED MODULE: ./ecosystems/layout.register.tsx
var layout_register_excluded = ["className"];function layout_register_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function layout_register_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? layout_register_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : layout_register_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var Footer = footer_register;
var layout_register_Icon = (0,styled_components_browser_esm["default"])(Icon/* default */.Z).withConfig({ displayName: "layoutregister__Icon", componentId: "sc-1olt87h-0" })(["", ""],
function (props) {return (
    props.whiteOnDesktop ? "\n      @media (min-width: ".concat(

    props.theme.viewports.laptop, "px) {\n        :before {\n          color: ").concat(

    props.theme.colors.neutrals.white, ";\n          text-shadow: 0 1px 4px #000000bf;\n        }\n      }\n  ") :




    '');});


// we allow style extention because
// logo changes color on some viewports
var Logo = function Logo(_ref) {var _ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className,props = (0,objectWithoutProperties/* default */.Z)(_ref, layout_register_excluded);
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(layout_register_Icon, layout_register_objectSpread({
      fontSize: "24px",
      name: "ygb-icon-yogobe-logo2019_1",
      className: className },
    props)));


};

var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "layoutregister__Wrapper", componentId: "sc-1olt87h-1" })(["min-height:100vh;height:100%;display:flex;flex-direction:column;@media(min-width:", "px){flex-direction:row;}", ""],










function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;},



function (_ref3) {var customStyle = _ref3.customStyle;return customStyle;});


// abstraction for Left/Right containers
var Side = styled_components_browser_esm["default"].div.withConfig({ displayName: "layoutregister__Side", componentId: "sc-1olt87h-2" })(["", ""],





function (_ref4) {var _ref4$customStyle = _ref4.customStyle,customStyle = _ref4$customStyle === void 0 ? '' : _ref4$customStyle;return customStyle;});


var LeftContainer = (0,styled_components_browser_esm["default"])(Side).withConfig({ displayName: "layoutregister__LeftContainer", componentId: "sc-1olt87h-3" })(["@media(min-width:", "px){flex:5;}"],
function (_ref5) {var theme = _ref5.theme;return theme.viewports.laptop;});




var RightContainer = (0,styled_components_browser_esm["default"])(Side).withConfig({ displayName: "layoutregister__RightContainer", componentId: "sc-1olt87h-4" })(["@media(min-width:", "px){flex:6;}"],
function (_ref6) {var theme = _ref6.theme;return theme.viewports.laptop;});




// TODO: enhance original paragraph in typography
var Paragraph = styled_components_browser_esm["default"].p.withConfig({ displayName: "layoutregister__Paragraph", componentId: "sc-1olt87h-5" })(["color:", ";font-size:", "px;line-height:", "px;font-weight:", ";text-align:", ";", " margin:10px 0;", " ", " ", " ", " ", ""],














function (_ref7) {var color = _ref7.color;return color ? color : '#242424';},
function (_ref8) {var size = _ref8.size;return size ? size : 20;},
function (_ref9) {var lineHeight = _ref9.lineHeight;return lineHeight ? lineHeight : 28;},
function (_ref10) {var weight = _ref10.weight;return weight ? weight : '500';},


function (_ref11) {var center = _ref11.center;return center ? 'center' : 'left';},
function (_ref12) {var crossed = _ref12.crossed;return crossed ? 'text-decoration: line-through;' : '';},


function (props) {return props.hasOwnProperty('mt') ? "margin-top: ".concat(props.mt, "px;") : '';},
function (props) {return props.hasOwnProperty('mr') ? "margin-right: ".concat(props.mr, "px;") : '';},
function (props) {return (
    props.hasOwnProperty('mb') ? "margin-bottom: ".concat(props.mb, "px;") : '');},
function (props) {return props.hasOwnProperty('ml') ? "margin-left: ".concat(props.ml, "px;") : '';},

function (_ref13) {var customStyle = _ref13.customStyle;return customStyle;});


// This file should probably not be changed anymore
// we have two templates, FormTemplate and ConfirmationTemplate
var RegisterLayout = /*#__PURE__*/react.memo(function (_ref14) {var children = _ref14.children;
  return children({
    Wrapper: Wrapper,
    LeftContainer: LeftContainer,
    RightContainer: RightContainer,
    Paragraph: Paragraph,
    Footer: Footer,
    Logo: Logo });

});

/* harmony default export */ var layout_register = (RegisterLayout);

/***/ }),

/***/ 40154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _ecosystems_layout_register__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61231);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



var RightContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_ecosystems_layout_register__WEBPACK_IMPORTED_MODULE_2__.RightContainer).withConfig({ displayName: "registerFormpageTemplate__RightContainer", componentId: "sc-1b1jwz7-0" })(["position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:", ";"],





function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.white;});


var LeftContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_ecosystems_layout_register__WEBPACK_IMPORTED_MODULE_2__.LeftContainer).withConfig({ displayName: "registerFormpageTemplate__LeftContainer", componentId: "sc-1b1jwz7-1" })(["display:flex;justify-content:center;"]);




var LeftContainerComponent = function LeftContainerComponent(_ref2) {var _ref2$className = _ref2.className,className = _ref2$className === void 0 ? '' : _ref2$className,children = _ref2.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LeftContainer, { className: className, children: children });
};

var RightContainerComponent = function RightContainerComponent(_ref3) {var _ref3$className = _ref3.className,className = _ref3$className === void 0 ? '' : _ref3$className,children = _ref3.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(RightContainer, { className: className, children: children });
};

/* harmony default export */ __webpack_exports__["Z"] = (_objectSpread(_objectSpread({},
_ecosystems_layout_register__WEBPACK_IMPORTED_MODULE_2__), {}, {
  RightContainer: RightContainerComponent,
  LeftContainer: LeftContainerComponent }));

/***/ }),

/***/ 57846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85169);
/* harmony import */ var _components_form_FormGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(774);
/* harmony import */ var _components_form_NewInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74014);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49613);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35925);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48354);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var AccessCodeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({ displayName: "AccessCodeInput__AccessCodeWrapper", componentId: "sc-1ajbqxf-0" })(["display:flex;align-items:flex-end;"]);




var Label = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].label.withConfig({ displayName: "AccessCodeInput__Label", componentId: "sc-1ajbqxf-1" })(["display:block;max-width:513px;width:100%;font-weight:600;margin-top:20px;input{height:47px;margin-top:8px;}"]);












var ApplyCodeButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_components_buttons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({ displayName: "AccessCodeInput__ApplyCodeButton", componentId: "sc-1ajbqxf-2" })(["flex-shrink:0;height:47px;min-width:60px;font-size:14px;color:#0000008a;text-transform:capitalize;padding:0 14px;margin-left:10px;i:before{color:rgba(0,0,0,0.54);}svg{font-size:24px;margin-bottom:-5px;}"]);




















var HelperText = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].span.withConfig({ displayName: "AccessCodeInput__HelperText", componentId: "sc-1ajbqxf-3" })(["display:flex;align-items:center;font-size:13px;color:", ";margin-top:10px;"],



function (_ref) {var theme = _ref.theme,_error = _ref._error,_success = _ref._success;
  if (_error) {
    return theme.colors.secondary['red-1'];
  } else if (_success) {
    return theme.colors.secondary['green-2'];
  } else {
    return theme.colors.neutrals.black;
  }
});




















var AccessCodeInput = function AccessCodeInput(props) {
  var
  inputName =












  props.inputName,error = props.error,value = props.value,handleBlur = props.handleBlur,validatedAccessCode = props.validatedAccessCode,validationState = props.validationState,clearAccessToken = props.clearAccessToken,checkAccessCodeValidity = props.checkAccessCodeValidity,onChange = props.onChange,inputLabel = props.inputLabel,validationText = props.validationText,loading = props.loading,_props$buttonText = props.buttonText,buttonText = _props$buttonText === void 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { name: "ygb-icon-checkmark" }) : _props$buttonText;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_form_FormGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        errorMsg: error,
        marginBottom: 0, children: /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(AccessCodeWrapper, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Label, { children: [
            /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(inputLabel) ?
            inputLabel : /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_8__/* .Trans */ .cC, { id: inputLabel }), /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_form_NewInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              name: inputName,
              value: value,
              onBlur: handleBlur,
              onChange: onChange,
              onKeyDown: function onKeyDown(e) {
                if (
                e.key === 'Enter' &&
                value &&
                !loading &&
                !validatedAccessCode)
                {
                  checkAccessCodeValidity();
                }
              } })] }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ApplyCodeButton, {
            type: "button",
            appearance: "outline",
            loading: loading,
            onClick: function onClick() {
              if (validatedAccessCode) {
                clearAccessToken();
              } else if (value) {
                checkAccessCodeValidity();
              }
            }, children:


            validatedAccessCode ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { fontSize: "inherit", color: "inherit" }) :

            buttonText })] }) }),




      validationText ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(HelperText, {




        _success: validationState === _gql_generated__WEBPACK_IMPORTED_MODULE_4__/* .CodeStatusKind.Valid */ .jWO.Valid,
        _error: validationState === _gql_generated__WEBPACK_IMPORTED_MODULE_4__/* .CodeStatusKind.Invalid */ .jWO.Invalid, children:

        validationText }) :

      null] }));


};

/* harmony default export */ __webpack_exports__["Z"] = (AccessCodeInput);

/***/ })

}]);